<template>
  <div class="view-container">
    <vue-portal to="hrsys-navbar-actions">
      <div class="flex">
        <base-header-title :title="$t('modules.clients')"/>
        <vx-tooltip :text="$t('buttons.create')" class="ml-2" position="bottom">
          <base-button @click="$router.push({ name: 'clientDetails', params: { id: 0 } })" class="self-end px-3"
                       icon="plus"/>
        </vx-tooltip>
      </div>
    </vue-portal>

    <base-loader :loading="loadingContent">
      <base-search @search="search" v-model="queryParams.search"/>
      <clients-table :clients="list"
                     :header="tableHeader"
                     @delete="deleteClientPrompt"
                     @edit="editClient"/>
      <pagination :pagination="pagination" @input="changePage" v-if="pagination.total"/>
    </base-loader>
  </div>
</template>

<script>
  import ClientsTable from '../../components/clients/ClientsTable'
  import Pagination from '../../components/Pagination'
  import Clients from '../../services/Clients'

  export default {
    name: 'Clients',
    components: {
      ClientsTable,
      Pagination
    },
    data: () => ({
      list: [],
      pagination: {},
      queryParams: {
        page: 1,
      },
      loadingContent: false
    }),
    methods: {
      editClient (clientId) {
        this.$router.push({name: 'clientDetails', params: {id: clientId}})
      },
      changePage (newPage) {
        this.queryParams.page = newPage
        this.$router.push({query: this.queryParams}).catch(() => {
        })
        this.getClients()
      },
      getClients () {
        this.loadingContent = true
        Clients.list(this.queryParams).then(response => {
          this.$router.push({query: this.queryParams}).catch(() => {
          });
          this.list = response.data
          this.pagination = response.meta.pagination
        }).finally(() => this.loadingContent = false)
      },
      deleteClientPrompt (id) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: this.$t('clients.deleteTitle'),
          text: this.$t('clients.deleteText'),
          accept: () => {
            this.deleteClient(id)
          }
        });
      },
      deleteClient (id) {
        this.loadingContent = true
        Clients.delete(id).then(() => {
          this.$notificationService.success(`${this.$t('clients.client')} ${this.$t('notification.successDelete')}`)
          this.getClients()
        }).catch((e) => {
          this.$notificationService.error(e.message)
        }).finally(() => {
          this.loadingContent = false
        })
      },
      search () {
        this.$router.push({query: this.queryParams}).catch(() => {
        })
        this.queryParams.page = 1
        this.getClients()
      },
      getUrlParams () {
        let vm = this;
        if (this.$route.query.page) {
          vm.queryParams = Object.assign({}, vm.$route.query);
        }
      },
    },
    computed: {
      tableHeader () {
        return ([
          this.$t('clients.table.name'),
          this.$t('clients.table.email'),
          this.$t('clients.table.phone'),
          this.$t('clients.table.actions')
        ])
      }
    },
    mounted () {
      this.getUrlParams()
      this.getClients()
    },
  }
</script>

<style scoped>

</style>
